<template>
    <Transition name="fade">
        <DbRegist v-if="isRegist" :isRegist="isRegist" :planner="planner" :planner_id="planner_id" :year="year" :month="month" :toggleRegist="toggleRegist" :getAllRequestDB="getAllRequestDB"></DbRegist>
    </Transition>

    <div class="container-fluid">
        <div class="row">
            <!-- DB 할당 -->
            <div class="col-md-12 mb-3">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-12">
                                <h6><i class="fas fa-user-cog onmaum-text-dental text-sm opacity-10"></i> DB 할당 현황</h6>
                            </div>
                            <div class="col-md-12">
                                <div class="onmaum-alert onmaum-alert-dental" role="alert">
                                    <ul>
                                        <li>DB 할당 현황 조회 방법 => '연도'와 '월' 선택 후 '조회'</li>
                                        <li>
                                            DB 할당 방법
                                            <ul>
                                                <li>1. 조회 결과에서 '등록' 클릭</li>
                                                <li>2. 고객정보 입력창(모달창)에 고객정보 입력 후 '등록'</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div class="row">
                            <div class=" col-lg-6 col-md-3 mb-1">
                                
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4 mb-1">
                                <select id="listYear" class="form-control" v-model="listYear">
                                    <option selected="selected" value="">연도선택</option>
                                    <option v-for="(year, i) in years" :key="i" :value="year">{{ year }}</option>
                                </select>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4 mb-1">
                                <select id="listMonth" class="form-control" v-model="listMonth">
                                    <option selected="selected" value="">월선택</option>
                                    <option v-for="(month, i) in months" :key="i" :value="month">{{ month }}</option>
                                </select>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4 mb-1">
                                <button class="btn btn-success w-100" @click="getAllRequestDB()">조회</button>
                            </div>
                            <div class="col-12 p-0">
                                <div class="table-responsive p-0 onmaum-overflow-type02">
                                    <table class="table table-striped text-center table align-items-center mb-0">
                                        <thead>
                                            <tr>
                                                <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="" >플래너</th>
                                                <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="" >연/월</th>
                                                <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="" >등록/요청</th>
                                                <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="" >등록</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(request, i) in allRequestDB" :key="i">
                                                <!-- 플래너 -->
                                                <td class="p-0">
                                                    <p class="text-sm font-weight-bold mb-0">{{ request.planner }}</p>
                                                </td>
                                                <!-- 연/월 -->
                                                <td class="p-0">
                                                    <p class="text-sm font-weight-bold mb-0">{{ request.year }}/{{ request.month }}</p>
                                                </td>
                                                <!-- 등록/요청 건수 -->
                                                <td class="p-0">
                                                    <p class="text-sm font-weight-bold mb-0">{{ request.regist }}/{{ request.count }}</p>
                                                </td>
                                                <!-- 요청 건수 -->
                                                <td class="p-0">
                                                    <p class="text-sm font-weight-bold mb-0 onmaum-text-default-hover" @click="registDB(request.planner, request.planner_id, request.year, request.month)">등록</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <!-- <div class="col-9 p-0">
                                <div class="table-responsive p-0 onmaum-overflow-type02">
                                    <table class="table table-striped text-center table align-items-center mb-0">
                                        <thead>
                                            <tr>
                                                <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="" v-for="(num, j) in Array(31)" :key="j">{{ j + 1 }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(request, i) in allRequestDB" :key="i">
                                                <td class="p-0" v-for="(num, j) in Array(31)" :key="j">
                                                    <p class="text-sm font-weight-bold mb-0">{{ j % 3 }}</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div> -->
                        </div>
                        
                    </div>

                    
                </div>
            </div>

            <!-- 치과 리스트 관리 -->
            <div class="col-md-12 mb-3">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-12">
                                <h6><i class="fas fa-hospital onmaum-text-success text-sm opacity-10"></i> 치과 목록 관리</h6>
                            </div>
                            <div class="col-md-12">
                                <div class="onmaum-alert onmaum-alert-success" role="alert">
                                    <ul>
                                        <li>치과 정보를 관리할 수 있습니다.</li>
                                        <li>신규입력, 삭제만 가능하고 수정을 원할 시에는 '삭제' 후 '신규입력'을 하시면 됩니다.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div class="table-responsive p-0 onmaum-overflow-type02">
                            <table class="table table-striped text-center table align-items-center">
                                <thead>
                                    <tr>
                                        <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="" >번호</th>
                                        <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="" >치과명</th>
                                        <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="" >기타정보</th>
                                        <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="" >버튼</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(hospital, i) in hospitals" :key="i">
                                        <!-- 번호 -->
                                        <td>
                                            <p class="text-sm font-weight-bold mb-0">{{ i + 1 }}</p>
                                        </td>
                                        <!-- 치과명 -->
                                        <td>
                                            <input class="text-sm font-weight-bold mb-0 form-control" :id="`hospitalName${i}`" :value="hospital.name" disabled/>
                                        </td>
                                        <!-- 기타 정보 -->
                                        <td>
                                            <input class="text-sm font-weight-bold mb-0 form-control" :id="`hospitalEtc${i}`" :value="hospital.etc" disabled/>
                                        </td>
                                        <!-- 버튼 -->
                                        <td>
                                            <div class="row">
                                                <div class="col-lg-12 col-md-12 col-sm-12 mb-1">
                                                    <p v-if="!isNewMode && !isModifyMode" class="onmaum-text-default-hover btnModify" :id="`btnModify${i}`" @click="modify(i)"><i class="fas fa-trash text-sm opacity-10"></i> 삭제</p>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 mb-1">
                                                    <p v-if="!isNewMode && isModifyMode" class="onmaum-text-success-hover btnSave" :id="`btnSave${i}`" @click="save(hospital.name)"><i class="fas fa-check text-sm opacity-10"></i> 예</p>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 mb-1">
                                                    <p v-if="!isNewMode && isModifyMode" class="onmaum-text-red-hover btnCancel" :id="`btnCancel${i}`" @click="cancel()"><i class="fas fa-undo text-sm opacity-10"></i> 아니오</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="newHospital.length > 0">
                                        <td>
                                            <p class="text-sm font-weight-bold mb-0">신규</p>
                                        </td>
                                        <!-- 치과명 -->
                                        <td>
                                            <input class="text-sm font-weight-bold mb-0 form-control" v-model="newHospital[0].name"/>
                                        </td>
                                        <!-- 기타 정보 -->
                                        <td>
                                            <input class="text-sm font-weight-bold mb-0 form-control" v-model="newHospital[0].etc"/>
                                        </td>
                                        <!-- 버튼 -->
                                        <td>
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-sm-6 mb-1">
                                                    <!-- <button v-if="isNewMode" class="btn btn-success w-100" @click="newSave()">저장</button> -->
                                                    <p v-if="isNewMode" class="onmaum-text-success-hover" @click="newSave()"><i class="fas fa-save text-sm opacity-10"></i> 저장</p>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 mb-1">
                                                    <!-- <button v-if="isNewMode" class="btn btn-outline-dark w-100" @click="newCancel()">취소</button> -->
                                                    <p v-if="isNewMode" class="onmaum-text-red-hover" @click="newCancel()"><i class="fas fa-undo text-sm opacity-10"></i> 취소</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="text-center mt-2">
                            <button v-if="!isNewMode && !isModifyMode" class="btn btn-success" @click="newInsert()"><i class="fas fa-plus-circle text-sm opacity-10 text-white"></i> 신규입력</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import DbRegist from './DbRegist.vue';

export default {
    name: 'dbManage',
    
    data(){
        return{
            listYear: '',
            listMonth: '',

            isRegist: false,
            planner: '',
            planner_id: 0,
            year: 0,
            month: 0,

            newHospital: [],

            isNewMode: false,
            isModifyMode: false,
        }
    },
    
    methods: {
        //플래너별 DB 요청 및 할당 현황 조회
        getAllRequestDB(){
            this.$store.dispatch('getAllRequestDB', {year: this.listYear, month: this.listMonth});
        },

        //고객 등록 팝업 띄우기
        registDB(planner, planner_id, year, month){
            console.log(`${planner_id}-${planner}/${year}/${month}`);

            this.planner = planner;
            this.planner_id = +planner_id;
            this.year = +year;
            this.month = month;
            this.isRegist = true;
        },

        //DB 등록창 여닫기
        toggleRegist(){
            this.isRegist = !this.isRegist;
        },

        //삭제
        modify(id){
            this.isModifyMode = true;
            console.log(id);
        },

        //삭제-예
        save(name){
            this.$store.dispatch('deleteHospital', { name: name });
            this.isModifyMode = false;
        },

        //삭제-아니오
        cancel(){
            this.isModifyMode = false;
        },

        //신규입력
        newInsert(){
            this.newHospital.push({name: '', etc: ''});
            this.isNewMode = true;
        },

        //신규입력 저장
        newSave(){
            //DB 저장
            this.$store.dispatch('insertHospital', { hospital: this.newHospital });

            //초기화
            this.newHospital = [];
            this.isNewMode = false;
        },

        //신규입력 취소
        newCancel(){
            this.newHospital = [];
            this.isNewMode = false;
        },
    },

    computed: {
        years(){
            let result = [];
            let dt = new Date();
            result.push('' + dt.getFullYear());
            result.push('' + (+dt.getFullYear() + 1));

            return result;
        },

        months(){
            return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        },

        counts(){
            let result = Array(30);
            for(let i = 0; i < result.length; i++){
                result[i] = '' + (i + 1);
            }

            return result;
        },

        allRequestDB(){
            return this.$store.getters.getAllRequestDB;
        },
        
        hospitals(){
            return this.$store.getters.getHospitalInfo;
        },
    },

    components: {
        DbRegist,
    },

    mounted(){
        //치과 정보 가져오기
        this.$store.dispatch('getHospitalInfo');
    }
}
</script>

<style>

</style>